import { newsList } from '@src/data/news';
import styled from 'styled-components';
import { MdKeyboardArrowRight } from 'react-icons/md';
import Link from 'next/link';
import { devices } from '@src/styles/theme';
const News = () => {
  return (
    <>
      {newsList.map((item, i) => (
        <Container onClick={() => {}}>
          <Link href={item.link} target="_blank">
            <ContentWrap>
              <ContentWrap>
                <Index>{i + 1 > 9 ? i : '0' + (i + 1)}</Index>
                <Col>
                  <Title>{item.title}</Title>
                  <NewsSource>{item.newsPaper}</NewsSource>
                </Col>
              </ContentWrap>
              <ArrowIcon />
            </ContentWrap>
          </Link>
        </Container>
      ))}
    </>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 15px 25px;
  border-bottom: 1px solid ${({ theme }) => theme.commonColor.gray002};
  cursor: pointer;
`;

const ContentWrap = styled.div`
  /* flex: 1; */
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Index = styled.div`
  color: ${({ theme }) => theme.commonColor.pink004};
  font-weight: 400;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 50px;
  @media ${devices.tablet} {
    margin-left: 20px;
  }
`;

const Title = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.commonColor.black};
`;

const NewsSource = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.commonColor.gray005};
  margin-top: 8px;
`;

const ArrowIcon = styled(MdKeyboardArrowRight)`
  width: 24px;
  height: 24px;
`;

export default News;
